import {
    AllocationElementAnchor,
    AllocationElementVersion,
} from 'src/models/anchor-and-version/allocation-element.model';
import { Component, inject } from '@angular/core';
import { AllocationElementService } from 'src/services/anchor-and-version-services/allocation-element.service';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-allocation-element-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudAllocationElementModalComponent extends CrudModalAbstractComponent<
    AllocationElementAnchor,
    AllocationElementVersion
> {
    public modalProps: ModalProps = {
        title: 'Allocation Element',
        validateNameFormat: false,
        anchorFields: [
            {
                field: 'allocationElementId',
                label: 'ID',
                tooltip: 'Suggested lowest unused ID. Duplicates are allowed.',
                type: 'number',
                required: true,
                order: 2,
                getDefaultValue: () => this.allocationElementService.getNextAvailableId(),
            },
            {
                field: 'componentAnchorKey',
                label: 'Component',
                type: 'lazy-dropdown',
                required: true,
                order: 4,
            },
        ],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 3 },
            { field: 'documentation', label: 'Documentation', type: 'textarea', order: 5 },
            { field: 'description', label: 'Description', type: 'textarea', order: 6 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 7 },
            { field: 'isActive', label: 'Is Active', type: 'switch', order: 8 },
        ],
    };

    protected allocationElementService = inject(AllocationElementService);
}
